// @flow

import _ from 'lodash';
import { connect } from 'react-redux';
import { reduxForm, isValid } from 'redux-form';

import { createWithResources } from 'client/actions/user';
import { getAddressFromZip } from 'client/actions/geo';
import { postEmailSubscription } from 'client/actions/subscribe';
import PreRegistration from 'client/components/preRegistration/preRegistration';

const FORM_TYPE = 'preReg';

const mapStateToProps: Object = (state, ownProps) => {
  const { user } = state;
  const { isLoggedIn, primaryMemberId } = user;
  const contentfulData = JSON.parse(ownProps.preregistration);
  const firstName = _.get(user, 'primary_member.first_name', null);
  const commonTranslations = _.get(state, 'translations.common', {});
  const isEmptyCart = _.isEmpty(_.get(state, 'cart.ifpApps', []));

  return {
    commonTranslations,
    contentfulData,
    firstName,
    formData: _.get(state, 'form.preReg.values'),
    isEmptyCart,
    isLoggedIn,
    isValidForm: isValid('preReg')(state),
    phase3Enabled: _.get(state, 'phase3Enabled'),
    memberDashboard: _.get(state, 'memberDashboard'),
    primaryMemberId,
  };
};

const DecoratedPreRegistrationForm = reduxForm({ form: FORM_TYPE })(PreRegistration);

export default connect(mapStateToProps, {
  createWithResources,
  getAddressFromZip,
  postEmailSubscription,
})(DecoratedPreRegistrationForm);
